import React, { Component } from "react";
import { QuestionTypes } from "../../../../constants/QuestionTypes";
import { getResponse } from "../../../../services/formService";
import * as Icon from "react-feather";
import Tooltip from "@material-ui/core/Tooltip";

class MatrixViewer extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Number: this.props.Question_Number,
    Question_Answers: this.props.Question_Answers,
    Matrix_QAs: this.props.Matrix_Answers,
    Matrix_Questions: this.props.Matrix_Questions,
    Matrix_Answers: [],
    uniqueQs: [],
    uniqueQs: [],
    isMultiple: this.props.isMultiple,
    isTally: false,
    Responses: [],
    Response_Required: this.props.Response_Required,
    Required_Count: 0,
    PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : "",
    Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
    loading: true,
  };

  async componentDidMount() {

    let uniqueQAs = [...new Set(this.state.Question_Answers.map(item => item.Answer_Text))],
        uniqueQs = [...new Set(this.state.Matrix_Questions.map(item => item.Question_ID))],
        //uniqueANum = [...new Set(this.props.Matrix_Answers.map(item => item.Answer_Number))],
        Matrix_Answers = [];

    uniqueQs.forEach(q => {
      Matrix_Answers = [...Matrix_Answers, this.props.Matrix_Answers.filter((a) => a.Question_ID === q)];
    });

    this.setState({ uniqueQs, uniqueQAs, Matrix_Answers })
    let Responses = [], uQ, Required_Count = 0;
    for (uQ of uniqueQs) {
      let q = this.state.Matrix_Questions.filter((mQ) => mQ.Question_ID === uQ)[0],
        isTally = q && q.Question_Type_ID === QuestionTypes.Numeric_Tally;
      this.setState({ isTally });

      if (this.state.Response_Required) {
        if (isTally) Required_Count += this.state.Matrix_Answers.length;
        else Required_Count++;
      }

      let Response = {};
      for (let answer of this.props.Matrix_Answers.filter((mA) => mA.Question_ID === uQ)) {
        if (!isTally) {
          Response['Answer_ID'] = answer.Answer_ID;
        } else {
          Response['Answer_ID'] = 0;
        }
      }

      let { data: subR } = await getResponse(this.state.PrimaryKey, this.state.Project_ID, q.Question_ID);
      for (let response of subR) {
        if (isTally) {
          Response['Answer_ID'] = parseFloat(response.Answer_Text);
        } else {
          response.Answer_ID && (Response['Answer_ID'] = response.Answer_ID) && (Response['Answer_Text'] = response.Answer_Text);
        }
      }

      Responses.push({
        Question_ID: q.Question_ID,
        Answer_ID: Response['Answer_ID'],
        Answer_Text: Response['Answer_Text']
      });
    }
    this.setState({ Required_Count, Responses, loading: false  });
    //console.log('Responses', Responses);
  }

  handleResponse = (target, idx, ansId) => {
    let Responses = this.state.Responses;
    if (this.state.isTally) {
      Responses[idx].Answer_Text = parseFloat(target.value);
    }
    else {
      if (this.state.isMultiple) {
        if ((Responses[idx].Answer_Text) === undefined) {
          Responses[idx].Answer_Text = target.value
        }
        else if (target.checked && !(Responses[idx].Answer_Text).includes(target.value)) {
          Responses[idx].Answer_Text = Responses[idx].Answer_Text + ',' + target.value
        }
        else if (!target.checked && (Responses[idx].Answer_Text).includes(target.value)) {
          Responses[idx].Answer_Text = ((Responses[idx].Answer_Text).split(',')).filter((r) => r != target.value).toString()
        }
      }
      else {
        Responses[idx].Answer_Text = target.value
      }
    }

    this.setState({ Responses });
    this.props.OnUpdate(this.props.Question_Number, {
      Question_Number: this.props.Question_Number,
      Responses: Responses.filter((resp) => resp.Answer_Text !== undefined).length < this.state.Required_Count ? 
                  [] : Responses.filter((resp) => resp.Answer_Text !== undefined),
      Response_Required: this.state.Response_Required,
      Question_Number: this.props.Question_Number
    });
  };

  render() {
    if (this.state.loading) return <div className="center">Loading...</div>;

    const { Question_ID, uniqueQs, uniqueQAs, Matrix_Questions, Matrix_Answers, isMultiple, isTally, Responses } = this.state;

    return (
      <table
        className="table table-hover table-bordered" key={"matrix" + Question_ID}>
        <thead>
          <tr>
            <th></th>
            {uniqueQAs.map((QA, idx) => {
              return (
                <th scope="col" key={idx}>
                  {QA}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {uniqueQs.map((mQ, idx) => {
            return (
              <tr key={'mQ:' + mQ}>
                <th scope="row">
                  {Matrix_Questions.filter((q) => q.Question_ID === mQ)[0].Question_Text}
                  {Matrix_Questions.filter((q) => q.Question_ID === mQ)[0].Description && (
                    <Tooltip title={Matrix_Questions.filter((q) => q.Question_ID === mQ)[0].Description} placement="top">
                      <Icon.Info size={18} />
                    </Tooltip>
                  )}
                </th>
                {Matrix_Answers[idx].map((mA, mAIdx) => {
                  return (
                    <td key={"pQ:" + mA.Question_ID + "subQ:" + mAIdx}>
                      {Matrix_Answers[idx].Deleted !== null && (
                        <input
                          key={isMultiple ? ("pQ:" + mA.Question_ID + "subQ:" + mAIdx) : "pQ:" + mA.Question_ID}
                          type={isTally ? "number" : isMultiple ? "checkbox" : "radio"}
                          checked={!isTally ? (Responses[idx]['Answer_Text']) && (Responses[idx]['Answer_Text']).indexOf(mA.Answer_Text) !== -1 : ''}
                          value={isTally ? Responses[idx]['Answer_Text'] : mA.Answer_Text}
                          className={isTally ? "form-control" : ""}
                          name={isMultiple ? ("pQ:" + mA.Question_ID + "subQ:" + mAIdx) : "pQ:" + mA.Question_ID}
                          onChange={(e) => this.handleResponse(e.target, idx, mA.Answer_ID)}
                          onClick={(e) => this.handleResponse(e.target, idx, mA.Answer_ID)}
                        />
                      )}
                    </td>
                  )
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default MatrixViewer;
